<template>
  <jti-expansion-panel panelName="Price Chart Details">
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-container grid-list-lg>
        <v-text-field
          v-model="data.name"
          label="Name"
          :readonly="readonly"
          required
          :rules="[rules.required]"
        ></v-text-field>
        <v-text-field
          v-model="data.code"
          label="Code"
          :readonly="readonly"
          required
          :rules="[rules.required]"
        ></v-text-field>
        <v-select
          v-model="data.route_id"
          label="Branch"
          :items="routes"
          :readonly="readonly"
          required
          :rules="[rules.required]"
        ></v-select>
        <v-select
          v-model="data.vehicle_layout_id"
          label="Vehicle Layout"
          :items="vehicleLayouts"
          :readonly="readonly"
          required
          :rules="[rules.required]"
        ></v-select>
      </v-container>
    </v-form>
  </jti-expansion-panel>
</template>

<script>
export default {
  props: {
    data: Object,
    readonly: Boolean,
    routes: Array,
    vehicleLayouts: Array
  },
  computed: {
    computedData() {
      return {
        id: this.data.id,
        name: this.data.name,
        code: this.data.code,
        route_id: this.data.route_id,
        vehicle_layout_id: this.data.vehicle_layout_id
      };
    }
  },
  data() {
    return {
      valid: true,
      rules: {
        required: value => !!value || "This field is required.",
        counter: value => value.length <= 20 || "Max 20 characters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      }
    };
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    }
  }
};
</script>

<style scoped>

</style>
